export * from './predicates';

// Re-export to not break old code
export { EPredicateFields, EPredicateOperators, ESearchPredicateTypes } from '@common/definitions';
export type { Predicate } from '@common/types/objects';
